import { API_BASE_URL } from './api';

/**
 * URL para servir la foto de avatar de un usuario, o `null` si no tiene
 * foto (en cuyo caso el componente Avatar pinta el círculo con iniciales).
 *
 * El `?v=` lleva el timestamp de `avatarUpdatedAt` para cache-busting: el
 * navegador cachea agresivo (Cache-Control del backend) entre cambios y
 * refetch-ea sólo cuando el avatar cambia. La imagen se carga con un `<img
 * src>` directo (same-origin → la cookie de sesión viaja sola), no a través
 * del cliente `api()` que parsea JSON.
 */
export function avatarUrl(userId: string, avatarUpdatedAt: string | null): string | null {
  if (!avatarUpdatedAt) return null;
  const v = Date.parse(avatarUpdatedAt);
  const version = Number.isNaN(v) ? '' : `?v=${v}`;
  return `${API_BASE_URL}/users/${userId}/avatar${version}`;
}
